module.exports = __webpack_public_path__ + "img/mobile-catch-title.ad62900c.svg";